
import Vue from "vue";
import AppContactEdit from "@/components/contacts/ContactEdit.vue";
import { Contact } from "@/models/base";
import { IModal } from "@/services/modal-service";

export default Vue.extend({
	data(){
		return {
			contact: new Contact()
		};
	},
	props: {
		modal: {
			type: Object as ()=>IModal,
			required: true
		},
	},
	methods: {
		close(){
			this.$emit("close", this.contact);
			if (this.modal.callback){
				if (this.contact.ID == 0){
					this.modal.callback(null);
				}else{
					this.modal.callback(this.contact);
				}
			}
		},
		onContact(contact:Contact){
			this.contact = contact;
		}
	},
	created(){
		let data = this.modal.data as {
			contact?:Contact;
			groupId:number;
		};
		if (data.contact){
			this.contact = data.contact;
		}
		this.contact.GroupID = data.groupId;
	},
	components: {
		AppContactEdit,
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
